export default __webpack_public_path__ + "static/img-app-graphs-f789634c5933ed79b2a61db10c086d9a.webp";